/** LyX toolbar icons (lib/images/*.svgz), generated by scripts/gen-lyx-icons.py — do not edit. */
export const LYX_ICONS: Record<string, string> = {
  'accept': '/lyxicons/accept.svg',
  'acceptall': '/lyxicons/acceptall.svg',
  'addcol': '/lyxicons/addcol.svg',
  'addrow': '/lyxicons/addrow.svg',
  'aligncenter': '/lyxicons/aligncenter.svg',
  'aligndecimal': '/lyxicons/aligndecimal.svg',
  'alignleft': '/lyxicons/alignleft.svg',
  'alignright': '/lyxicons/alignright.svg',
  'alllines': '/lyxicons/alllines.svg',
  'borderlines': '/lyxicons/borderlines.svg',
  'boxinset': '/lyxicons/boxinset.svg',
  'cases': '/lyxicons/cases.svg',
  'changenext': '/lyxicons/changenext.svg',
  'changesoutput': '/lyxicons/changesoutput.svg',
  'charstyles': '/lyxicons/charstyles.svg',
  'cite': '/lyxicons/cite.svg',
  'colleft': '/lyxicons/colleft.svg',
  'colright': '/lyxicons/colright.svg',
  'copy': '/lyxicons/copy.svg',
  'cut': '/lyxicons/cut.svg',
  'delcol': '/lyxicons/delcol.svg',
  'delimsize': '/lyxicons/delimsize.svg',
  'delrow': '/lyxicons/delrow.svg',
  'depthin': '/lyxicons/depthin.svg',
  'depthout': '/lyxicons/depthout.svg',
  'description': '/lyxicons/description.svg',
  'display': '/lyxicons/display.svg',
  'emph': '/lyxicons/emph.svg',
  'enumerate': '/lyxicons/enumerate.svg',
  'ert': '/lyxicons/ert.svg',
  'find': '/lyxicons/find.svg',
  'float': '/lyxicons/float.svg',
  'footnote': '/lyxicons/footnote.svg',
  'formallines': '/lyxicons/formallines.svg',
  'graphics': '/lyxicons/graphics.svg',
  'href': '/lyxicons/href.svg',
  'include': '/lyxicons/include.svg',
  'index': '/lyxicons/index.svg',
  'innerlines': '/lyxicons/innerlines.svg',
  'itemize': '/lyxicons/itemize.svg',
  'label': '/lyxicons/label.svg',
  'labeling': '/lyxicons/labeling.svg',
  'layout': '/lyxicons/layout.svg',
  'linebottom': '/lyxicons/linebottom.svg',
  'lineleft': '/lyxicons/lineleft.svg',
  'lineright': '/lyxicons/lineright.svg',
  'linetop': '/lyxicons/linetop.svg',
  'macro': '/lyxicons/macro.svg',
  'marginal': '/lyxicons/marginal.svg',
  'math': '/lyxicons/math.svg',
  'mathpanelstb': '/lyxicons/mathpanelstb.svg',
  'mathtb': '/lyxicons/mathtb.svg',
  'matrix': '/lyxicons/matrix.svg',
  'mfrac': '/lyxicons/mfrac.svg',
  'mint': '/lyxicons/mint.svg',
  'mprod': '/lyxicons/mprod.svg',
  'mroot': '/lyxicons/mroot.svg',
  'msqrt': '/lyxicons/msqrt.svg',
  'msum': '/lyxicons/msum.svg',
  'multicolumn': '/lyxicons/multicolumn.svg',
  'multirow': '/lyxicons/multirow.svg',
  'navback': '/lyxicons/navback.svg',
  'new': '/lyxicons/new.svg',
  'nolines': '/lyxicons/nolines.svg',
  'nomencl': '/lyxicons/nomencl.svg',
  'note': '/lyxicons/note.svg',
  'noun': '/lyxicons/noun.svg',
  'open': '/lyxicons/open.svg',
  'outline': '/lyxicons/outline.svg',
  'outputsync': '/lyxicons/outputsync.svg',
  'paragraph': '/lyxicons/paragraph.svg',
  'paste': '/lyxicons/paste.svg',
  'redo': '/lyxicons/redo.svg',
  'ref': '/lyxicons/ref.svg',
  'reject': '/lyxicons/reject.svg',
  'rejectall': '/lyxicons/rejectall.svg',
  'reviewtb': '/lyxicons/reviewtb.svg',
  'rotatecell': '/lyxicons/rotatecell.svg',
  'rotatetable': '/lyxicons/rotatetable.svg',
  'rowdown': '/lyxicons/rowdown.svg',
  'rowup': '/lyxicons/rowup.svg',
  'section': '/lyxicons/section.svg',
  'spellcheck': '/lyxicons/spellcheck.svg',
  'sub': '/lyxicons/sub.svg',
  'sup': '/lyxicons/sup.svg',
  'table': '/lyxicons/table.svg',
  'tablefloat': '/lyxicons/tablefloat.svg',
  'tabletb': '/lyxicons/tabletb.svg',
  'textstyle': '/lyxicons/textstyle.svg',
  'thesaurus': '/lyxicons/thesaurus.svg',
  'track': '/lyxicons/track.svg',
  'undo': '/lyxicons/undo.svg',
  'update': '/lyxicons/update.svg',
  'updatemaster': '/lyxicons/updatemaster.svg',
  'valignbottom': '/lyxicons/valignbottom.svg',
  'valignmiddle': '/lyxicons/valignmiddle.svg',
  'valigntop': '/lyxicons/valigntop.svg',
  'vccheckin': '/lyxicons/vccheckin.svg',
  'vccompare': '/lyxicons/vccompare.svg',
  'vclog': '/lyxicons/vclog.svg',
  'vcregister': '/lyxicons/vcregister.svg',
  'vcrepoupdate': '/lyxicons/vcrepoupdate.svg',
  'view': '/lyxicons/view.svg',
  'viewmaster': '/lyxicons/viewmaster.svg',
};
